import React, { FC, useMemo, useState } from 'react';
import { getFieldName, getFormData } from './category4LayoutData';
import FieldsRow from 'shared/components/FieldsRow';
import { Col, Row } from 'antd';
import { IndexBadge } from 'shared/components/IndexBadge';
import { CATEGORY4CONSTANTS } from 'constants/Scope3Constants/category4.constants';
import styles from './category4.module.scss';
import { SwitchChangeEventHandler } from 'antd/lib/switch';
import { useFormContext } from 'react-hook-form';
import { FormType } from 'enums/FieldTypeEnums';
import RHFSwitch from 'shared/components/ReactHookFormFields/RHFSwitch';
import { Category1Types } from 'enums/category1Enums';
import { CategoryItem } from 'models/Scope3/categoryItems.model';
import CreateSupplierModal from 'shared/components/CreateSupplierModal';
import SupplierService from 'services/ValueChainService/supplier.service';
import { TransportationConstants } from 'views/CreateProductFlow/Transportation/TransportationConstants';
import { Supplier } from 'models/Supplier/Supplier.model';
import { convertToOptions } from 'views/CreateProductFlow/RawMaterial/RawMaterialHelper';
import { limitParam } from '..';
interface Catgeory4LayoutProps {
  type: Category1Types;
  index: number;
  item?: CategoryItem;
  supplierList?: Supplier[];
  fetchSuppliers?: (params?: {
    page?: number;
    size?: number;
    name?: string;
  }) => Promise<void>;
}

const {
  LABELS,
  FIELD_TRANSPORT_OWNED_BY_COMPANY,
  FIELD_OWNED_VEHICLES,
  FIELD_SUPPLIER,
  FIELD_TEMPERATURE_CONTROL,
  FIELD_TRANSPORTATION_VIA_AIR,
  FIELD_TRANSPORTATION_COST,
  FIELD_PRIMARY_MODE_OF_TRANSPORT,
  FIELD_UNIT,
} = CATEGORY4CONSTANTS;

const { USER_DETAILS } = TransportationConstants;
const user = localStorage.getItem(USER_DETAILS);
const parsedUser = !!user ? JSON.parse(user) : '';

const switchLabel = (
  <Row className={styles.switchLabel}>{LABELS.TRANSPORT_OWNED_BY_COMPANY}</Row>
);

const Catgeory4Layout: FC<Catgeory4LayoutProps> = ({
  type,
  index,
  item,
  supplierList,
  fetchSuppliers,
}) => {
  const { setValue, watch } = useFormContext();

  const [createSupplierModalState, setCreateSupplierModalState] =
    useState<boolean>(false);

  const { loading, createSupplier } = SupplierService();

  const getName = (name: string) => getFieldName(type, index, name);
  const switchField = getName(FIELD_TRANSPORT_OWNED_BY_COMPANY);
  const ownedVehicleField = getName(FIELD_OWNED_VEHICLES);
  const supplierField = getName(FIELD_SUPPLIER);
  const temperatureControlField = getName(FIELD_TEMPERATURE_CONTROL);
  const transportationViaAirField = getName(FIELD_TRANSPORTATION_VIA_AIR);
  const transportationCostField = getName(FIELD_TRANSPORTATION_COST);
  const primaryModeOfTransportField = getName(FIELD_PRIMARY_MODE_OF_TRANSPORT);
  const unitField = getName(FIELD_UNIT);

  const switchValue = watch(switchField);

  //Have added two instead of a single toggle, since the existing supplier modal expects the same
  const openSuppliermodal = () => setCreateSupplierModalState(true);
  const closeSuppliermodal = () => setCreateSupplierModalState(false);

  const formData = useMemo(() => {
    const supplierOptions = convertToOptions(supplierList ?? []);
    return getFormData({
      index,
      type,
      disableOwnedVehicles: switchValue,
      supplierOptions,
      openSuppliermodal,
    });
  }, [switchValue, index, type, supplierList]);

  const handleSwitchChange: SwitchChangeEventHandler = checked => {
    if (checked) {
      setValue(ownedVehicleField, 100);
      if (type === Category1Types.OTHERS) {
        setValue(transportationCostField, null);
        setValue(primaryModeOfTransportField, null);
        setValue(unitField, null);
      } else {
        setValue(supplierField, null);
        setValue(temperatureControlField, null);
        setValue(transportationViaAirField, null);
      }
    } else {
      setValue(ownedVehicleField, 0);
      setValue(transportationViaAirField, false);
    }
  };

  const addSupplierCallback = async (supplierId: string) => {
    await fetchSuppliers?.(limitParam);
    supplierId &&
      setValue(supplierField, Number(supplierId), {
        shouldTouch: true,
        shouldValidate: true,
      });
  };
  return (
    <Row align="top" gutter={[15, 15]} className={styles.contentWrapper}>
      <Col className={styles.indexBadge} span={1}>
        {item?.uniqueId && <IndexBadge index={item?.uniqueId - 1} />}
      </Col>
      <Col span={23}>
        <Row align="middle" gutter={[15, 20]}>
          <Col span={24}>
            <Row align="middle" gutter={[15, 15]}>
              <Col>
                <Row align="middle" gutter={[5, 0]}>
                  <Col className={styles.ingredientName}>
                    {`${item?.name ?? ''} -`}
                  </Col>
                  <Col className={styles.ingredientLocation}>
                    {item?.origin}
                  </Col>
                </Row>
              </Col>
              <Col>
                <RHFSwitch
                  name={getFieldName(
                    type,
                    index,
                    FIELD_TRANSPORT_OWNED_BY_COMPANY
                  )}
                  label={switchLabel}
                  onChange={handleSwitchChange}
                />
              </Col>
            </Row>
          </Col>
          <Col span={24} className={styles.fieldsRow}>
            <FieldsRow
              {...formData}
              rowClassName={styles.wrapClassname}
              formType={FormType.REACT_HOOK_FORMS}
            />
          </Col>
          <CreateSupplierModal
            showModalState={createSupplierModalState}
            handleModalCancel={closeSuppliermodal}
            handleModalConfirm={closeSuppliermodal}
            createSupplier={createSupplier}
            id={parsedUser.id}
            successCallback={addSupplierCallback}
            loading={loading}
          />
        </Row>
      </Col>
    </Row>
  );
};

export default Catgeory4Layout;
